module.exports = {
      id: "nutstore-2-pic-usage",
      viewBox: "0 0 500 304",
      url: __webpack_public_path__ + "images/js_src_vue/common/sprite.61ac148b.svg#nutstore-2-pic-usage",
      toString: function () {
        return this.url;
      }
    }